export enum VerificationType {
  MailAddress = 'mail',
  ChangePassword = 'change-password',
  TwoFactorLogin = 'two-factor-login',
  EnableTwoFactor = 'enable-two-factor',
  ForgotPassword = 'forgot-password',
  ChangeMail = 'change-mail',
  SensitiveAction = 'sensitive-action',
  UpdatePassword = 'update-password',
}
